import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '影片分类',
      links: [
        { label: '动作片', path: '/category/action' },
        { label: '喜剧片', path: '/category/comedy' },
        { label: '科幻片', path: '/category/scifi' },
        { label: '爱情片', path: '/category/romance' },
        { label: '恐怖片', path: '/category/horror' },
      ],
    },
    {
      title: '剧集资源',
      links: [
        { label: '国产剧', path: '/category/cn-drama' },
        { label: '韩剧', path: '/category/kr-drama' },
        { label: '美剧', path: '/category/us-drama' },
        { label: '综艺', path: '/category/variety' },
        { label: '纪录片', path: '/category/documentary' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', path: '/about' },
        { label: '联系方式', path: '/about#contact' },
        { label: '使用指南', path: '/article/qiyou-viewing-guide' },
        { label: '常见问题', path: '/#faq' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="inline-block">
                <span className="text-xl font-heading font-bold text-primary-500">奇优影院</span>
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                免费在线观影平台，提供最新最全的电影、电视剧、综艺、动漫资源。无广告、不收费、高清流畅。
              </p>
            </div>
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-800 mb-4">{group.title}</h4>
                <ul className="space-y-2">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 奇优影院 qiyoucinema.com 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-primary-500 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-primary-500 transition-colors">服务条款</a>
              <a href="#" className="hover:text-primary-500 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}